import React from 'react';
import './App.css';

import Header from './Header/Header';
import Main from './Main/Main';

function App(): JSX.Element {
  return (
    <div className="grid-container">
      <Header/>
      <Main/>
    </div>
  );
}

export default App;
